import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../app.service';
import { CustomerContactService } from '../customer-contact/add-new-user-cl/customer-contact.service';
import { crsfVM, EquipmentTabforCuatomerContact } from '../customer-contact/Models/customer-contact.model';
import { CustomerTab } from '../customer-contact/Models/customer-details.model';
import { CustomerService } from '../GET_NEW_UI/services/customer.service';
import { AddNewEquipmentUcComponent } from './add-new-equipment-uc/add-new-equipment-uc.component';
import { AddNewJobsiteUcComponent } from './add-new-jobsite-uc/add-new-jobsite-uc.component';
import { AddNewUserUcComponent } from './add-new-user-uc/add-new-user-uc.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-user-contact',
  templateUrl: './user-contact.component.html',
  styleUrls: ['./user-contact.component.scss']
})
export class UserContactComponent implements OnInit {


  title = 'TrackTradeUI';
  contain: Contain[] = [
    {value: 0, viewValue: 'Begins with'},
    {value: 1, viewValue: 'Contains'},
    {value: 2, viewValue: 'Ends with'}
  ]; 
  
  constructor( private _contactService:CustomerContactService,
    public dialog: MatDialog, @Inject(DOCUMENT) private _document: Document,
    private _customerService:CustomerService,
    private _notify: NotificationsService,
    private _appService: AppService,) { }


  UserList:any;
  selectedUserId:number=0
  selectedTab:number=0
  showError:boolean=false
  selectedCustomer:number=1
  userLsit:CustomerTab[];
  JobsiteListForTab:crsfVM[];
  CustomerNameForgroupingTab:crsfVM[];
  EquipmentListForTab:EquipmentTabforCuatomerContact[]
  ngOnInit() {
    this._appService.setPageTitle('User Contact');
  //  this.GetuserDetails();
  this.getUserInfoforUserContact();
  }

 
  getUserInfoforUserContact(){

    this._contactService.GetAllFacilitatorsForUser().subscribe(res=>{
      this.UserList = res;
    });
    // this._contactService.getUserInfoforUserContact().subscribe(res=>{
    //   this.UserList = res;
  
    //   //console.log("this.userlist",this.UserList);
    // })
  }
  //

  getContactToUser(){
    if(!this.selectedUserId)
  {
    return;
  }
    this._customerService.getContactToUser(this.selectedUserId).subscribe(res=>{
      
      this.userLsit = res;
  
      //console.log('This.cust1',res);
    })
  }


  getcustomernamesInfobyUserforgrouping()
  {
    if(!this.selectedUserId)
    {
      return;
    }
    this._customerService.getcustomernamesInfobyUserforgrouping(this.selectedUserId).subscribe(res=>{
     this.CustomerNameForgroupingTab = res;
     // console.log('This.CustomerNameForgroupingTab grouping',res);
    })

  }

  GetJobsitebyUser(){
    // if(!this.selectedUserId)
    // {
    //   return;
    // }
    this._customerService.GetJobsitebyUser(this.selectedUserId).subscribe(res=>{
      this.JobsiteListForTab = res;
     // console.log('This.selectedUserId',res);
    })
  }



  
  GetEquipmentbyUserId()
  {

  if(!this.selectedUserId)
    {
      return;
    }
    this._customerService.GetEquipmentbyUserId(this.selectedUserId).subscribe(res=>{
      this.EquipmentListForTab = res;
     // console.log('This.GetEquipmentbyUserId',res);
    })
  }

  openAddNewCustomerDialog(): void {
  
   // console.log("this.selectedcustomer",this.selectedUserId)
     if(this.selectedUserId>0)
     {
       this.showError=false
       if(this.selectedTab==0){
         this.openCustomerLevelDialog();
       }else if(this.selectedTab==1){
         this.openJobSiteLevelDialog();
       }else if(this.selectedTab==2){
         this.openEquipmentLevelDialog();
       }
     }else if(this.selectedUserId<=0 || this.selectedUserId ==null){
       this.showError=true
    } 
 }

 onChangeCustomer()
 {
  //console.log("SELcet ",this.selectedUserId)
  this.getContactToUser();
 this.GetEquipmentbyUserId();
  
  this.GetJobsitebyUser();
 this.getcustomernamesInfobyUserforgrouping();
  //add next one
  
 // console.log("this.selectedUserId",this.selectedUserId)
 }
openCustomerLevelDialog(){
  console.log("selected customer when open dialog", this.selectedUserId)
  const dialogRef = this.dialog.open(AddNewUserUcComponent, { 
    disableClose: true,
    data:{
      userId:this.selectedUserId,
      
      
    }
    });

 dialogRef.afterClosed().subscribe(result => {
   if(result==true){
     console.log('click add')
   }else if(result==false){
    console.log('The dialog was closed');
   this.getContactToUser();
   }
  
  
 });
}

openJobSiteLevelDialog(){
  //console.log("selected customer when open job sitedialog", this.selectedUserId)
  const dialogRef = this.dialog.open(AddNewJobsiteUcComponent, { 
    disableClose: true,
    data:{
      //siteName:this.selectedSite,
      userId:this.selectedUserId,
      JobsiteListForTab:this.JobsiteListForTab
    }

    });

 dialogRef.afterClosed().subscribe(result => {
 
   this.GetJobsitebyUser();
   this.getcustomernamesInfobyUserforgrouping()
  
 });
}
openEquipmentLevelDialog(){
  const dialogRef = this.dialog.open(AddNewEquipmentUcComponent, { 
    disableClose: true,
    data:{
      //siteName:this.selectedSite,
      userId:this.selectedUserId,
      EquipmentListForTab:this.EquipmentListForTab
    }
    });

 dialogRef.afterClosed().subscribe(result => {
   if(result==true){
     console.log('click add')
   }else if(result==false){
    console.log('The dialog was closed');
    this.GetEquipmentbyUserId();
   }
   
  
 });
}

fieldsChange(values:any,item:CustomerTab,num:number):void {
  console.log(values.checked);
  console.log(item);
if(num==1){
  item.EvalA=values.checked;
}
if(num==2){
  item.EvalB=values.checked;
}
if(num==3){
  item.EvalC=values.checked;
}
if(num==4){
  item.EvalX=values.checked;
}
if(num==5){
  item.wty_letter=values.checked;
}
if(num==6){
  item.eq_health=values.checked; 
}
if(num==7){
  item.eq_undercarriage=values.checked;
}

}

fieldsChangeJobsite(values:any,item:crsfVM,num:number):void {
  console.log(values.checked);
  console.log(item);
if(num==1){
  item.EvalA=values.checked;
}
if(num==2){
  item.EvalB=values.checked;
}
if(num==3){
  item.EvalC=values.checked;
}
if(num==4){
  item.EvalX=values.checked;
}
if(num==5){
  item.wty_letter=values.checked;
}
if(num==6){
  item.service=values.checked;
}
if(num==7){
  item.eq_undercarriage=values.checked;
}
if(num==8){
  item.eq_health=values.checked;
}
 
}

fieldsChangeEquipment(values:any,item:EquipmentTabforCuatomerContact,num:number):void {
  console.log(values.checked);
  console.log(item);
if(num==1){
  item.EvalA=values.checked;
}
if(num==2){
  item.EvalB=values.checked;
}
if(num==3){
  item.EvalC=values.checked;
}
if(num==4){
  item.EvalX=values.checked;
}
if(num==5){
  item.wty_letter=values.checked;
}
if(num==6){
  item.service=values.checked;
}
if(num==7){
  item.eq_undercarriage=values.checked;
}

if(num==8){
  item.eq_health=values.checked;
}
 
}


updatecustomerRow()
{
 
  this._customerService.UpdateConCL(this.userLsit).subscribe(res =>
    {
if(res)
{
  
  this._notify.success('Updated');

}
    })
      
}



updateJobsiteRow()
{
  this._customerService.UpdateConJSL(this.JobsiteListForTab).subscribe(res =>
    {
      if(res)
    {
     
  this._notify.success('Updated')
     }

    })
   
    
  
}

updateEquipmentRow()
{
  this._customerService.UpdateConEL(this.EquipmentListForTab).subscribe(res =>
    {
      if(res)
    {
       
  this._notify.success('Updated')
    }

    })

    
}



update()
{
  if(this.selectedTab==0){
    this.updatecustomerRow();
  }else if(this.selectedTab==1){
    this.updateJobsiteRow();
  }else if(this.selectedTab==2){
    this.updateEquipmentRow();
   }
 
}

deleletecoatactList:CustomerTab[]=[];
fieldsChange_(values:any,item:CustomerTab)
{
   let array_= [];
  array_ =  this.deleletecoatactList

  if(values.checked==true){
    if(array_.length>0 ){
      let has=array_.find(x=>x.customer_auto == item.customer_auto)
      if(!has){
        array_.push(item);
        this.deleletecoatactList = array_;
      }
    }
    else{
      array_.push(item);
      this.deleletecoatactList = array_;
    }
    
  }else{
    this.deleletecoatactList = this.deleletecoatactList.filter(x=>x.customer_auto !=item.customer_auto);
  }
 
  
  //console.log("this.deleletecoatactList", this.deleletecoatactList)

}
deleleteJobsiteList:crsfVM[]=[];
fieldsChangeJobsite_(values:any,item:CustomerTab)
{
   let array_= [];
  array_ =  this.deleleteJobsiteList

  if(values.checked==true){
    if(array_.length>0 ){
      let has=array_.find(x=>x.crsf_auto == item.crsf_auto)
      if(!has){
        array_.push(item);
        this.deleleteJobsiteList = array_;
      }
    }
    else{
      array_.push(item);
      this.deleleteJobsiteList = array_;
    }
    
  }else{
    this.deleleteJobsiteList = this.deleleteJobsiteList.filter(x=>x.crsf_auto !=item.crsf_auto);
  }
 

}


deleleteEquipList:EquipmentTabforCuatomerContact[]=[];
fieldsChangeEquipment_(values:any,item:EquipmentTabforCuatomerContact)
{
   let array_= [];
  array_ =  this.deleleteEquipList

  if(values.checked==true){
    if(array_.length>0 ){
      let has=array_.find(x=>x.equipmentid_auto == item.equipmentid_auto)
      if(!has){
        array_.push(item);
        this.deleleteEquipList = array_;
      }
    }
    else{
      array_.push(item);
      this.deleleteEquipList = array_;
    }
    
  }else{
    this.deleleteEquipList = this.deleleteEquipList.filter(x=>x.equipmentid_auto !=item.equipmentid_auto);
  }
 
  
  //console.log("this.deleleteEquipList", this.deleleteEquipList)

}


deleteCustomerRow()
{ 
  this._customerService.DeleteCLdata(this.deleletecoatactList).subscribe((res: any) =>
    {
if(res)
{
  this.getContactToUser();
}
    })
    
}


deleteJobsiteRow()
{
  this._customerService.DeleteJSdata(this.deleleteJobsiteList).subscribe(res =>
    {
if(res)
{
  this.GetJobsitebyUser();
}
    })
    
}
deleteEquipmentRow()
{
  
  this._customerService.deleteEqData(this.deleleteEquipList).subscribe(res =>
    {
      if(res)
      {
        this.GetEquipmentbyUserId();
      }

    })
    
}

delete()
{
  if(this.selectedTab==0){
    this.deleteCustomerRow();
  }else if(this.selectedTab==1){
    this.deleteJobsiteRow();
  }else if(this.selectedTab==2){
    this.deleteEquipmentRow();
   }
  

 
}
}

export interface Contain {
  value: number;
  viewValue: string;
}